// app/javascript/controllers/collapse_visibility_controller.js
import { Controller } from "@hotwired/stimulus"

// Connects to elements with data-controller="collapse-visibility"
export default class extends Controller {

  static values = {
    targetSelector: String
  }

  connect() {
    // console.log(`connect row ${this.element.id}`)
    // console.log(`targetSelector ${this.targetSelectorValue}`)

    // All child collapse targets (e.g., multiple <tr class="collapse">)
    this.childRows = document.querySelectorAll(this.targetSelectorValue)

    this.childRows.forEach(row => {
      // console.log(`adding listener for row ${row.id}`)
      row.addEventListener("shown.bs.collapse", (event) => this.updateSummary(event))
      row.addEventListener("hidden.bs.collapse", (event) => this.updateSummary(event))
    })

    // Do an initial check in case the collapse state is already set
    this.updateSummary()
  }

  updateSummary(event) {
    // console.log(`updateSummary ${event?.type}`)
    const anyShown = Array.from(this.childRows).some(row =>
      row.classList.contains("show")
    )

    // console.log(`anyShown? ${anyShown}`)

    // Toggle .invisible on any .summary-amount cells inside this.element
    this.element.querySelectorAll(".summary-amount").forEach(cell => {
      // console.log(`toggle invisible for cell ${cell.id}`)
      cell.classList.toggle("invisible", anyShown)
    })
  }
}
